import { withSuspenseLazy } from '@metrika/ui-kit';

export const SettingsLazyV2 = withSuspenseLazy(() => import('./SettingsV2'));
export const SettingsRouteLazy = withSuspenseLazy(() => import('./routes'));
